module.exports = __webpack_public_path__ + "static/media/gridIconSelected.3fa13d4e.svg";